import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import ShowChild from "src/components/panel/children/show/ShowChild";

const ShowChildView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("show_child_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb title={t("show_child_title")} />
        <ShowChild />
      </Sidebar>
    </>
  );
};

export default ShowChildView;
